import { Link } from 'react-router-dom';

export function NotFound(): JSX.Element {
  return (
    <div className="stack text-center">
      <h1 className="mt-0">Page not found</h1>
      <p className="muted">That page does not exist.</p>
      <div>
        <Link to="/" className="btn btn-primary">
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
